export const ContactData = [
    {
        Title:'الاميل',
        Info:'ahmedazouz022@gmail.com',
        LinkMail:'https://google.com',
    },
    {
        Title:'الوتس اب',
        Info:'+20 103505324',
        LinkMail:'https://www.facebook.com',
    },
    {
        Title:'ماستنجر',
        Info:'@ahmed.azouz',
        LinkMail:'https://www.facebook.com/messages/t/100083517627587',
    },
]